import { CardActionArea, CircularProgress, Paper, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import { alpha } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

interface StaffSlotProps {
  name: string;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

const StaffSlot = ({ name, onClick, selected, disabled, loading }: StaffSlotProps) => {
  const theme = useTheme();
  const isInteractive = !disabled && !selected && !loading;

  return (
    <Paper
      variant="outlined"
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'stretch',
        cursor: isInteractive ? 'pointer' : selected ? 'default' : 'not-allowed',
        borderColor: selected ? theme.palette.primary.main : undefined,
        borderWidth: selected ? 2 : undefined,
        backgroundColor: selected
          ? alpha(theme.palette.primary.main, 0.16)
          : loading
            ? alpha(theme.palette.primary.main, 0.08)
            : undefined,
        opacity: disabled && !selected && !loading ? 0.55 : 1,
        minHeight: 64,
      }}
      onClick={isInteractive ? onClick : undefined}
    >
      <CardActionArea
        onClick={isInteractive ? onClick : undefined}
        disabled={!isInteractive}
        style={{
          flex: 1,
          display: 'flex',
          padding: theme.spacing(2),
          gap: theme.spacing(2),
          minHeight: 64,
        }}
      >
        <Box flex={1} display="flex" flexDirection="column" justifyContent="center">
          <Typography>{name ?? '-'}</Typography>
          {selected && (
            <Box display="flex" alignItems="center" style={{ gap: 6, marginTop: 4 }}>
              <CheckCircleIcon color="primary" style={{ fontSize: '1.1rem' }} />
              <Typography variant="caption" color="primary">
                Already assigned
              </Typography>
            </Box>
          )}
        </Box>
        {loading && <CircularProgress size={22} />}
      </CardActionArea>
    </Paper>
  );
};

export default StaffSlot;
